import React from 'react';

import { classNames } from '@/helpers/classNames';
import constants from '@/theme/exportedVariables.module.scss';

import { Chip, ChipProps } from '../Chip';
import styles from './SongThemeChip.module.scss';

type SongThemeChipProps = {
	themeTag?: string | null;
} & Omit<ChipProps, 'content'>;

export const SongThemeChip: React.FC<SongThemeChipProps> = ({
	themeTag,
	className,
	...chipProps
}) => {
	const { className: songThemeClass } = getSongThemeColor(themeTag);
	const classes = classNames([
		songThemeClass && styles.songthemechip,
		songThemeClass,
	]);

	return (
		<Chip
			className={classNames([className, classes])}
			variant="rounded"
			{...chipProps}
			color="color-scheme"
		>
			{themeTag}
		</Chip>
	);
};

export const getSongThemeColor = (
	themeTag?: string | null,
): { className: string; colorHex: string; colorHexDark?: string } => {
	switch (themeTag?.toLowerCase()) {
		case 'fear':
			return {
				className: `px-color-scheme-teal`,
				colorHex: '#80ffa1',
			};
		case 'gravity of sin':
		case 'sin':
		case 'anger':
		case 'upbeat':
		case 'high':
			return {
				className: `px-color-scheme-red`,
				colorHex: '#ffaa9c',
			};
		case 'glory of god':
		case 'god':
		case 'hymn':
		case 'sadness':
			return {
				className: `px-color-scheme-purple`,
				colorHex: '#cec1f1',
			};
		case 'reflective':
		case 'surprise':
		case 'occasional':
			return {
				className: `px-color-scheme-aqua`,
				colorHex: '#62fbfc',
			};
		case 'chorus':
		case 'trust':
		case 'grandeur of grace':
		case 'grace':
		case 'settling':
		case 'regular':
			return {
				className: `px-color-scheme-green`,
				colorHex: '#c7ff4e',
			};
		case 'building':
		case 'joy':
		case 'low':
			return {
				className: `px-color-scheme-yellow`,
				colorHex: '#fcef48',
			};
		case 'disgust':
			return {
				className: `px-color-scheme-maroon`,
				colorHex: '#faa7b4',
			};
		case 'anticipation':
			return {
				className: `px-color-scheme-orange`,
				colorHex: '#f8c379',
			};
		case 'rest':
			return {
				className: `px-color-scheme-grey-inverse`,
				colorHex: '#f8c379',
			};
		default:
			return {
				className: `px-color-scheme-grey`,
				colorHex: '#d6d6e7',
				colorHexDark: '#484c7a',
			};
	}
};
